import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { FilterGroupButton } from './styled';

const GroupButton = ({ onClear, onApply }) => {
  return (
    <FilterGroupButton>
      <Button onClick={onClear}>Clear</Button>
      <Button onClick={onApply} type="primary">
        Apply
      </Button>
    </FilterGroupButton>
  );
};

GroupButton.propTypes = {
  onClear: PropTypes.func,
  onApply: PropTypes.func
};

export default GroupButton;
